export const row = 12;

export const templateMemberSize = {
  xs: row,
  sm: row / 2,
  md: row / 3,
  lg: row / 4,
};

export const defaultTemplateMemberSize = {
  xs: row / 2,
  sm: row / 4,
  md: row / 6,
  lg: row / 6,
};

export const templateFieldSectionSize = {
  xs: row / 2,
};

export const ruleRowNameSize = {
  xs: row / 4,
  sm: row / 6,
  md: row / 6,
  lg: row / 12,
};

export const ruleRowFieldsSize = {
  xs: row - ruleRowNameSize.xs,
  sm: row - ruleRowNameSize.sm,
  md: row - ruleRowNameSize.md,
  lg: row - ruleRowNameSize.lg,
};

export const accountNumberSize = {
  xs: row / 2,
  sm: row / 3,
  md: row / 4,
  lg: row / 6,
};

export const templateNameSize = {
  xs: row,
  sm: row / 2,
  md: row / 3,
  lg: row / 4,
};

export const accountNumberInputSize = {
  xs: 11,
  sm: 11,
  md: 10,
  lg: 10,
};

// lg: true will autosize columns to have same width
// no matter how many of them are there
export const generalSettingsSize = {
  xs: row,
  sm: row / 2,
  md: row / 3,
  lg: true,
};
